<template>
  <div class="echarts-wrapper">
    <template v-if="domName">
      <div class="canvas-box" :id="domName" :key="`province-${domName}`"></div>
    </template>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/map/js/province/shandong"; // 山东
import "echarts/map/js/province/anhui"; // 安徽
import "echarts/map/js/province/hubei"; // 湖北
import "echarts/map/js/province/guangdong"; // 广东
import "echarts/map/js/province/henan"; // 河南
import "echarts/map/js/province/jiangxi"; // 江西
import "echarts/map/js/province/liaoning"; // 辽宁
import "echarts/map/js/province/heilongjiang"; // 黑龙江
import "echarts/map/js/province/jiangsu"; // 江苏
import "echarts/map/js/province/qinghai"; // 青海
import "echarts/map/js/province/jilin"; // 吉林
import "echarts/map/js/province/fujian"; // 福建
import "echarts/map/js/province/shanxi"; // 山西
import "echarts/map/js/province/hebei"; // 河北
import "echarts/map/js/province/ningxia"; // 宁夏
import "echarts/map/js/province/hunan"; // 宁夏
import "echarts/map/js/province/sichuan"; // 四川
import "echarts/map/js/province/yunnan"; // 云南
import "echarts/map/js/province/guizhou"; // 贵州
import "echarts/map/js/province/zhejiang"; // 浙江
import "echarts/map/js/province/xinjiang"; // 新疆
import "echarts/map/js/province/neimenggu"; // 内蒙古
import "echarts/map/js/province/tianjin"; // 天津
import "echarts/map/js/province/shanxi1"; // 陕西
import "echarts/map/js/province/shanghai"; // 上海
import "echarts/map/js/province/guangxi"; // 广西
import "echarts/map/js/province/xizang"; // 西藏
import "echarts/map/js/province/gansu"; // 甘肃
import "echarts/map/js/province/beijing"; // 北京
import "echarts/map/js/province/chongqing"; // 重庆
import "echarts/map/js/province/hainan"; // 海南
// import "echarts/map/js/china";  // 中国

import statistics from "@/api/statistics";

import { nameMap, getOrgInfoByCode } from "./mapJSON/nameMap";
import { debounce } from "../../assets/js/utils";
import storage from "@/utils/storage";
/*
  绘制省份地图；
*/
export default {
  props: {
    statisticsToCounty: {},
    youthMap: {},
    domName: {
      type: String,
      required: true,
    },

    propsReloadTime: {
      type: Number,
      required: false,
      default: 30000,
    },
  },
  data() {
    return {
      echartsList: [], // resize方法用参数
      dataList: [],
      provinceName: "上海",
      userRole: storage.get("userInfo").userRole,
    };
  },

  computed: {
    chartsOption() {
      return {
        geo: {
          map: "china",
        },
        notMerge: true,
        // backgroundColor: "#FFFFFF",
        // title: {
        //   text: this.provinceName,
        //   top: 25,
        //   left: "center",
        //   textStyle: {
        //     fontSize: 25,
        //     fontWeight: 650,
        //     color: "#fff",
        //   },
        // },
        tooltip: {
          show: true,
          // formatter: "{b}<br/>{c} (人)",
          formatter: function (params) {
            let str = "";
            const item = params;
            str += `${item.name}: ${item.value | 0}`;
            if(item.data !== undefined && item.data.value_name){
              str += "（"+item.data.value_name+"）"
            }
            return str;
          },
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {},
          },
        },
        // visualMap: {
        //   //颜色的设置  dataRange
        //   textStyle: { color: "#fff" },
        //   x: "left",
        //   y: "bottom",
        //   min: 0,
        //   max: 1500,
        //   inRange: {
        //     color: [ "lightskyblue", "yellow", "orangered", "red"],
        //   },
        // },

        visualMap: {
          //颜色的设置  dataRange
          textStyle: { color: "#fff" },
          x: "left",
          y: "bottom",
          splitList: [
            { start: 20},
            { start: 16, end: 20 },
            { start: 11, end: 15 },
            { start: 6, end: 10 },
            { start: 1, end: 5 },
          ],
          // text:['高','低'],// 文本，默认为数值文本
          // color: ['#65A2D9', '#E09107', '#A3E00B']
          color: [
            "#FF0000",
            "#FFFF00",
            "#00FF00",
            "#0000FF",
            "#e97aff",
            "#8B00FF",
            "#a5fffd",
          ],
        },
        series: [
          {
            type: "map",
            map: this.provinceName, //这里需要注意呀,
            zoom: this.provinceName === "中国地图" ? 1.2 : 1,
            //mapType: "浙江",
            // 是否开启鼠标缩放和平移漫游 默认不开启
            itemStyle: {
              normal: {
                areaColor: "#fff", // 默认颜色
                borderColor: "#ccc",
              },
              emphasis: {
                areaColor: "#ccc", // 鼠标滑过颜色
                label: {
                  show: true,
                  color: "white",
                },
              },
            },
            roam: true,
            top: this.provinceName === "中国地图" ? 130 : 50,
            label: {
              show: true, // 是否显示对应地名
              fontSize: 10,
            },
            data: this.dataList,
            nameMap: nameMap,
            // nameMap: {
            //   '黄岛区': '黄岛'
            // }
          },
        ],
      };
    },

    orgId() {
      const { id } = this.$route.query;
      return id;
    },
  },

  mounted() {
    const that = this;
    that.yioksReGisterMap(); // 注册地图数据
    that.loadData(); // 加载数据
    window.onresize = debounce(
      function () {
        // 自动调整绘画区域大小
        that.echartsList.forEach((item) => {
          item();
        });
      },
      150,
      false
    );
  },

  methods: {
    /* 根据需求，注册部分市足协地图数据 */
    yioksReGisterMap() {
      const YANBIAN = require("./mapJSON/yb.json"); // 延边
      const QINGDAO = require("./mapJSON/qd.json"); // 青岛
      const CHENGDU = require("./mapJSON/cd.json"); // 成都
      const SHENYANG = require("./mapJSON/sy.json"); // 沈阳
      const KUNMING = require("./mapJSON/km.json"); // 昆明
      const SHENZHEN = require("./mapJSON/sz.json"); // 深圳
      const NANJING = require("./mapJSON/nj.json"); // 南京
      const DALIAN = require("./mapJSON/dl.json"); // 大连
      const XIAMEN = require("./mapJSON/xm.json"); // 厦门
      const CHANGCHUN = require("./mapJSON/cc.json"); // 长春
      const GUANGZHOU = require("./mapJSON/gz.json"); // 广州
      const WUHAN = require("./mapJSON/wh.json"); // 武汉
      const XIAN = require("./mapJSON/xa.json"); // 西安
      const CHINA = require("./mapJSON/chinaall.json"); // 中国
      echarts.registerMap("青岛", QINGDAO); // 注册地图
      echarts.registerMap("成都", CHENGDU);
      echarts.registerMap("沈阳", SHENYANG);
      echarts.registerMap("昆明", KUNMING);
      echarts.registerMap("深圳", SHENZHEN);
      echarts.registerMap("南京", NANJING);
      echarts.registerMap("大连", DALIAN);
      echarts.registerMap("厦门", XIAMEN);
      echarts.registerMap("长春", CHANGCHUN);
      echarts.registerMap("广州", GUANGZHOU);
      echarts.registerMap("武汉", WUHAN);
      echarts.registerMap("延边", YANBIAN);
      echarts.registerMap("西安", XIAN);
      echarts.registerMap("中国地图", CHINA);
    },

    drawProvince() {
      const mapDom = document.getElementById(this.domName);
      let chinaMapChart = echarts.init(mapDom);
      this.echartsList.push(chinaMapChart.resize);
      let optionChinaMap = this.chartsOption;
      chinaMapChart.clear();
      chinaMapChart.setOption(optionChinaMap);
    },

    // 加载数据
    loadData(){
      /* 处理地图数据 */
      let seriesData = [];
      for(let key in this.statisticsToCounty){
        let value = this.statisticsToCounty[key];
        let value_name = "";
        key = this.formateProvinceName(key);
//        if(key in this.youthMap){
//          value_name = this.youthMap[key]
//        }
        seriesData.push({
          name:key,
          value:value,
          value_name:value_name
        });
      }
      this.dataList = seriesData;

      // 应该暂时没用，最后删除看看
//      const mapInfo = getOrgInfoByCode("SH");
//      this.provinceName = mapInfo.mapName;
      // 结束

      this.drawProvince();
    },

    // 处理省字符串
    formateProvinceName(name = "") {
      return name.replace(/省|自治区|壮族自治区|回族自治区|维吾尔自治区|特别行政区/, "");
    },
  },
};
</script>

<style lang="stylus" scoped>
.echarts-wrapper
  width 100%
  height 100%
  .canvas-box
    width 100%
    height 100%
</style>
